import "../polyfills/abort";
import { Toaster } from "@newsela/angelou";
import Head from "next/head";
import PropTypes from "prop-types";

import AllPagesWrapper from "@/base/AllPagesWrapper";
import { TOASTER_Z_INDEX } from "@/base/base.constants";
import globalToasterRef from "@/base/globalToasterRef";
import InternalToolingPanel from "@/base/InternalToolingPanel";
import RootProviders from "@/base/RootProviders";

const propTypes = {
  Component: PropTypes.elementType,
  pageProps: PropTypes.shape({
    [RootProviders.InitialPropsName]: PropTypes.shape(RootProviders.propTypes),
    dehydratedState: PropTypes.object,
  }),
};

const NewselaApp = ({ Component, pageProps }) => {
  return (
    <RootProviders
      {...pageProps[RootProviders.InitialPropsName]}
      dehydratedState={pageProps?.dehydratedState}
    >
      <Head>
        <title>Newsela | Instructional Content Platform</title>
        <meta
          name="description"
          content="Newsela is an Instructional Content Platform that supercharges reading engagement and learning in every subject."
        />
      </Head>
      <AllPagesWrapper>
        <Component {...pageProps} />
        {/* `Toaster` is at the bottom because it defines an `h2`
         * element and we need to have an `h1` first. In addition,
         * `Toaster` should provide a "live region" instead of a
         * "region" (the way it is implemented at this moment), which
         * makes its location unimportant for accessibility. If a toast
         * pops up, it should be announced by by the screen reader.
         *
         * TODO: change Toaster's role to `status` instead of `region`.
         *
         * Reference:
         * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/status_role
         */}
        <Toaster
          ref={globalToasterRef}
          __cssFor={{
            root: {
              zIndex: TOASTER_Z_INDEX,
            },
          }}
        />
      </AllPagesWrapper>
      <InternalToolingPanel />
    </RootProviders>
  );
};

NewselaApp.propTypes = propTypes;

export default NewselaApp;
